module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/call-eedfa735fa065d448aec0886a83a2788.png";